document.addEventListener('DOMContentLoaded', () => {
  if (typeof carrotquest === 'undefined') {
    // eslint-disable-next-line no-console
    console.log('connect carrot script');

    const carrotTemplate = document.querySelector('#CarrotTemplate');

    if (carrotTemplate) {
      const { content } = carrotTemplate;
      const clone = document.importNode(content, true);

      document.body.appendChild(clone);
    }

    window.App = window.App || {};

    window.App.carrot = () => {
      if (window.App.carrot_userId && window.App.carrot_userHash) {
        carrotquest.auth(window.App.carrot_userId || '', window.App.carrot_userHash || '');
      }
    };
  }

  // Intercom activation
  document.addEventListener('click', (e) => {
    if (e.target.closest('.intercom-activate')) {
      if (typeof carrotquest === 'undefined') {
        const modal = document.querySelector('#intercom-blocked');

        if (modal) {
          // Show the modal by removing the _hidden class
          modal.classList.remove('_hidden');
        }

        return;
      }

      if ('open' in carrotquest) {
        carrotquest.open();
      }
    }
  });
});
